<section>
  <div>
    <form class="standard-form annual-plan-form" [formGroup]="annualPlanForm">
      <div class="small-input-header">Select Annual Improvement Plan Dates</div>
      <div class="calendar-inputs">
        <div class="calendar-container">
          <p-calendar id="startDate"
                      styleClass="strategies-calendar sm-cal"
                      [formControl]="startDateField"
                      inputStyleClass="standard-input"
                      placeholder="Start Date"
                      [maxDate]="endDate"
                      [showIcon]="true"
                      (onFocus)="resetCalendarEventBlocker()"
                      (onInput)="allowCalendarBlurEvent()"
                      (onSelect)="applyStartDate($event)"
                      (onBlur)="applyStartDate($event)">
          </p-calendar>
        </div>
        <div class="calendar-container">
          <p-calendar id="endDate"
                      styleClass="strategies-calendar sm-cal"
                      [formControl]="endDateField"
                      inputStyleClass="standard-input"
                      placeholder="End Date"
                      [minDate]="startDate"
                      [showIcon]="true"
                      (onFocus)="resetCalendarEventBlocker()"
                      (onInput)="allowCalendarBlurEvent()"
                      (onSelect)="applyEndDate($event)"
                      (onBlur)="applyEndDate($event)">
          </p-calendar>
        </div>
        <button auto= "annual-plan-view-btn" class="btn btn-primary view-btn" (click)="onViewAnnualPlan()"
                [disabled]="!hasRequiredFields">View</button>
      </div>
      <div class="error-message" *ngIf="hasNoPrioritiesAndSubmitted">
        <i class="fa fa-exclamation-triangle"></i>
        <span class="message-text">There are no initiatives within the dates provided</span>
      </div>
      <div class="error-message" *ngIf="hasEndDateWithNoStartDateAndTouched">
        <i class="fa fa-exclamation-triangle"></i>
        <span class="message-text">Please select a start date</span>
      </div>
      <div class="error-message" *ngIf="isEndDateBeforeStartDate">
        <i class="fa fa-exclamation-triangle"></i>
        <span class="message-text">Start date must be earlier than end date</span>
      </div>
    </form>
  </div>
  <div *ngIf="hasPriorities" class="initiative-content">
    <div *ngFor="let priorityGroup of groupedPriorities">
      <div *ngIf="hasInitiativesInPriorityGroup(priorityGroup)">
        <div class="title-wrapper">
          <div class="priority-title" [style.background-color]=
                 "priorityColorFromGroup(priorityGroup)">{{priorityNameFromGroup(priorityGroup)}}
          </div>
        </div>
          <ul class="initiative-list styleless">
            <li [ngClass]="{'no-bottom-border': true}">
              <div class="initiative-flex" [ngClass]="{'first-one': true}"
                   [style.border-color]="priorityColorFromGroup(priorityGroup)">
                <div class="initiative-details">
                  <h4>{{ headings.objectiveHeading }}</h4>
                  <div class="text">
                    <app-edit-overlay [isEditor]="!isEditItemDisabled"
                                      (planCoordinateChange)=
                                        "onPlanCoordinateChangeCreatingObjectivesAndCriticalInitiatives()">
                      <div class="initiative-description">{{priorityObjectiveFromGroup(priorityGroup)}}</div>
                    </app-edit-overlay>
                  </div>
                </div>
              </div>
              <div class="activities-container">
                <div *ngFor="let priority of priorityGroup">
                  <div *ngFor="let initiative of priority.initiatives" class="activity-container">
                    <div class="activity-main-content">
                      <div class="measures-and-targets">
                        <div class="measures no-border-left">
                          <div class="title"
                               [ngClass]="{'add-bottom-border': true}">{{headings.initiativeHeading}}
                          </div>
                          <app-edit-overlay class="allow-shrink"
                                            [isEditor]="!isEditItemDisabled"
                                            (planCoordinateChange)=
                                              "onPlanCoordinateChangeCreatingObjectivesAndCriticalInitiatives()">
                            <p class="initiative-description hard-break-text">{{initiative.initiative}}</p>
                          </app-edit-overlay>
                          <div class="initiative-date-container">
                            <app-edit-overlay class="allow-shrink"
                                              [isEditor]="!isEditItemDisabled"
                                              (planCoordinateChange)=
                                                "onPlanCoordinateChangeDevelopAnnualPlan()">
                              <div class="initiative-start-date">
                                <h4>Start Date:</h4>
                                <p>{{(initiative.startDate || '') | date:'MM/dd/yyyy'}}</p>
                              </div>
                              <div class="initiative-end-date">
                                <h4>End Date:</h4>
                                <p>{{(initiative.endDate || '') | date:'MM/dd/yyyy'}}</p>
                              </div>
                            </app-edit-overlay>
                          </div>
                        </div>
                        <div class="targets no-border-right">
                          <div class="title"
                               [ngClass]="{'add-bottom-border': true}">{{ headings.keyMeasureHeading }}
                          </div>
                          <app-edit-overlay class="allow-shrink"
                                            [isEditor]="!isEditItemDisabled"
                                            (planCoordinateChange)=
                                              "onPlanCoordinateChangeIdentifyOutcomesAndKeyMeasures()">
                            <ul class="styleless striped-list measure-target-list">
                              <ng-container *ngFor="let measure of initiative.measures">
                                <li class="target-list-item">
                                  <div class="target-measure break-text">{{measure|| 'Test'}}</div>
                                </li>
                              </ng-container>
                            </ul>
                          </app-edit-overlay>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
      </div>
    </div>
  </div>
</section>
